<script>
import api from "@/axios";
import Loader from "../components/loader";
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import appConfig from "@/app.config";
import Swal from "sweetalert2"
import { Vue3Lottie } from 'vue3-lottie'
import 'vue3-lottie/dist/style.css'
import animationJson from '@/assets/animations/clientes_anim.json'
import { clientesChart2 } from "../components/data-simulados"
import exportFromJSON from "export-from-json"
import ClientesTable from "./clientes-table"
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Clientes",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {Layout, PageHeader, ClientesTable, Loader, Vue3Lottie },
  mounted() {
    console.log('mounted clientes-list_0')
    this.atualizaDataList()
    this.atualizaDataGraph()
  },
  data() {
    return {
      animationJson,
      title: 'Clientes / Fornecedores / Transportadoras',
      items: [
        {
          text: 'Comercial',
          href: '/',
        },
        {
          text: 'Clientes / Fornecedores / Transportadoras',
          active: true,
        },
      ],
      loadingList: true,
      loadingGraph: true,
      clientesListPaged: null,
      cliChart1: null,
      cliChart2: clientesChart2,
      pesqTextFilter: '',
      statusFilter: 'T',
      currentPage: 1,

    }
  },

  methods: {

    onPageChange(){
      console.log('onPageChange')
      console.log(this.currentPage)
      this.atualizaDataList()
    },

    relatorio(){
      console.log('relatorio')
      this.loadingList = true

      api.get(`${getBaseUrl()}api/relcli1`, {
        responseType: 'blob'
      }).then((res) => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Relatorio_clientes_001.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.loadingList = false
      })

    },


    exportExcel(){
      console.log('exportExcel')
      const data = this.clientesListPaged.data
      const fileName = "exp_dados";
      const exportType = exportFromJSON.types.xls;
      if (data) exportFromJSON({ data, fileName, exportType });
    },

    atualizaDataList(){
      this.loadingList = true
      api.get(`${getBaseUrl()}api/clientes?page=${this.currentPage}`, {
        params: {
          'q': this.pesqTextFilter,
          's': this.statusFilter
        }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)

        this.clientesListPaged = res.data
        this.title = `(${this.clientesListPaged.total}) Clientes / Fornecedores / Transportadoras`
        this.loadingList = false

      })
    },

    atualizaDataGraph(){
      this.loadingList = true
      api.get(`${getBaseUrl()}api/clientesgr`).then((res) => {
        console.log('then axios graph')
        console.log(res.data)

        console.log('res.data[0]')
        console.log(res.data[0])
        let labelsLocG1 = []
        let series01G1 = []
        res.data[0].forEach((value) => {
          labelsLocG1.push(value.month)
          series01G1.push(value.contagem)
        })
        this.cliChart1 = {
          series: [{
            data: series01G1
          }],
          chartOptions: {
            chart: {
              toolbar: {
                show: false,
              }
            },
            plotOptions: {
              bar: {
                horizontal: true,
              }
            },
            dataLabels: {
              enabled: false
            },
            colors: ['#34c38f'],
            grid: {
              borderColor: '#f1f1f1',
            },
            xaxis: {
              categories: labelsLocG1,
            }
          }
        }
        let labelsLocG2 = []
        let series01G2 = []
        let contTotal = 0
        res.data[1].forEach((value) => {
          contTotal += parseInt(value.contagem)
        })
        console.log('contTotal_G2')
        console.log(contTotal)
        res.data[1].forEach((value) => {
          console.log(value)
          labelsLocG2.push(value.estado)
          const valorPerc = parseInt(value.contagem / contTotal * 100)
          console.log(valorPerc)
          series01G2.push(valorPerc)
        })
        this.cliChart2 = {
          series: series01G2,
          chartOptions: {
            labels: labelsLocG2,
            colors: ["#34c38f", "#556ee6", "#f46a6a", "#50a5f1", "#f1b44c"],
            legend: {
              show: true,
              position: 'bottom',
              horizontalAlign: 'center',
              verticalAlign: 'middle',
              floating: false,
              fontSize: '14px',
              offsetX: 0
            },
            responsive: [{
              breakpoint: 600,
              options: {
                chart: {
                  height: 240
                },
                legend: {
                  show: false
                },
              }
            }]
          }
        }

        this.loadingGraph = false
      })
    },

    deletaReg(dataID) {
      console.log('deletaReg_pai dataID:')
      console.log(dataID)
      this.loadingList = true
      api.delete(`${getBaseUrl()}api/cliente`, {
        params: {
          'iddata': dataID
        }
      }).then((res) => {
        console.log('then axios delete')
        console.log(res.data)
        this.atualizaDataList()
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações excluídas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
      })
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    }

  },
}
</script>

<template>
  <Layout>
    <span class="float-end" style="z-index: 1000; position: absolute; top: 30px; right: 210px;">
      <Vue3Lottie :animationData="animationJson" :height="200" :width="200" />
    </span>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">

              <div class="col-sm-2">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input
                        id="inputPesquisa"
                        type="text"
                        v-model="pesqTextFilter"
                        class="form-control"
                        placeholder="Enter para pesquisar..."
                        @change="atualizaDataList"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-1">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <select
                        id="selectStatus"
                        v-model="statusFilter"
                        @change="atualizaDataList"
                        class="form-control select2-search-disable">
                      <option value="T" selected>Todos</option>
                      <option value="A">Ativos</option>
                      <option value="I">Inativos</option>
                    </select>
                    <i class="bx bx-filter-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-2" >

                <b-dropdown
                    ngbDropdown
                    menu-class="dropdown-menu-md dropdown-menu-end"
                    right
                    variant="light">
                  <template v-slot:button-content>
                    <i class="mdi mdi-help me-1"></i>
                    <span class="d-none d-sm-inline-block" ngbDropdownToggle>
                      Auxiliar
                      <i class="mdi mdi-chevron-down"></i>
                    </span>
                  </template>


                  <div v-if="!loadingList">
                    <div class="dropdown-item-text">
                      <div>
                        <p class="text-muted mb-2">Total</p>
                        <h5 class="mb-0">{{ formatInteger(clientesListPaged.data.length) }} (ativos) </h5>
                      </div>
                    </div>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item>
                      Visitados:
                      <span class="float-end"> 0 (0%)</span>
                    </b-dropdown-item>
                    <b-dropdown-item>
                      Com Faturamento:
                      <span class="float-end"> 0 (0%)</span>
                    </b-dropdown-item>
                    <b-dropdown-item>
                      Com Devolução:
                      <span class="float-end"> 0 (0%)</span>
                    </b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <a class="dropdown-item text-primary text-center"
                       @click="exportExcel"
                       href="javascript: void(0);">
                      Exportar Excel
                    </a>

                    <b-dropdown-divider></b-dropdown-divider>
                    <a class="dropdown-item text-primary text-center"
                       @click="relatorio"
                       href="javascript: void(0);">
                      Relatório com Endereços
                    </a>

                  </div>

                </b-dropdown>
              </div>



              <div class="col-sm-7">
                <div class="text-sm-end">

                  <router-link :to="`/cliente/editar/0`">
                    <button type="button" class="btn btn-success btn-rounded mb-2 me-2" >
                      <i class="mdi mdi-plus me-1"></i> Novo Cliente
                    </button>
                  </router-link>

                </div>
              </div>
            </div>

            <Loader v-if="loadingList" style="min-height: 300px;">
            </Loader>


            <div v-if="!loadingList">


              <ClientesTable v-if="!loadingList"
                             :clientesList="clientesListPaged.data"/>


              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">

                      <b-pagination
                          v-model="currentPage"
                          :total-rows="clientesListPaged.total"
                          @update:modelValue="onPageChange">
                      </b-pagination>

                    </ul>
                  </div>
                </div>
              </div>
            </div>


          </div>

        </div>
      </div>
    </div>


    <Loader v-if="loadingGraph" style="min-height: 300px;">
    </Loader>


    <div class="row" v-if="!loadingGraph">

      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Evolução Mensal</h4>
            <apexchart
                class="apex-charts"
                type="line"
                height="370"
                :series="cliChart1.series"
                :options="cliChart1.chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Estados em Destaque</h4>
            <apexchart
                class="apex-charts"
                height="370"
                type="radialBar"
                dir="ltr"
                :series="cliChart2.series"
                :options="cliChart2.chartOptions"
            ></apexchart>

          </div>
        </div>
      </div>

    </div>

  </Layout>
</template>

